let api = process.env.REACT_APP_MKGF_MASTODON_API+'/checkin'

export const getCheckins = async (token, eventId) => {
    const headers = { 'Authorization': 'Bearer '+token }
    const response = await fetch(api+"/event/"+eventId , { headers });
    const data = await response.json();
    return data
}

export const checkinEvent = async ({token, id, user, hidden_from}) => {
    let body = {event_id: id, user, hidden_from}
    const headers = { 'Authorization': 'Bearer '+token, 'Content-Type': 'application/json' }
    const response = await fetch(api+"/" , { method:"POST", headers, body:JSON.stringify(body) });
    const data = await response.json();
    return data
}
